import {fancyClient, extractData} from '@freckle/educator-entities/ts/openapi-clients'

export async function postRequestChangePassword(password: string, code: string): Promise<void> {
  await fancyClient.POST('/2/passwords', {
    body: {password, code},
  })
}

type ResetPasswordResponse = {
  shouldLoginNow: boolean
}

export function postRequestPasswordReset(email: string): Promise<ResetPasswordResponse> {
  return fancyClient
    .POST('/2/passwords/resets', {
      body: {email},
    })
    .then(extractData)
}
